.electionHome {
  .tableTitle {
    margin-bottom: 1rem;
  }

  div.sessions {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    div.cards {
      display: flex;
      flex-wrap: wrap;
      gap: 2rem;
    }
  }

  div.line {
    border-bottom: 1px solid var(--gray-300);
  }
}

.alertActions {
  display: flex;
  gap: 1rem;
}

.electionInformationTable {
  width: 58.5rem;
}

.downloadDescription {
  width: 32rem;
  margin-bottom: var(--space-md);
}

main.backgroundBlue {
  background-color: var(--blue-100);

  article {
    background-color: var(--blue-100);
    display: flex;
    gap: 2rem;
  }
}

.reportInfoSection {
  margin-bottom: 2.5rem;
  width: 37.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  ol > li::marker {
    font-weight: bold;
  }
}

.subCommitteeKeys {
  display: flex;
  flex-direction: column;
  gap: var(--space-xl);

  section > div {
    display: flex;
    flex-direction: column;
    gap: var(--space-md-lg);

    div[role="alert"] {
      width: 58.5rem;
    }
  }

  .keysTable {
    width: 58.5rem;
  }
}

.certificateDetailSection {
  gap: var(--space-md-lg);
}

.certificateInformation {
  max-width: 32rem;
  border-radius: 0.5rem;
  overflow: hidden;

  display: flex;
  flex-direction: column;

  .certificateSection {
    background-color: var(--blue-200);
    padding: var(--space-md);
    font-family: var(--font-number);
    font-size: var(--font-size-xs);
    line-height: 1rem;
  }

  .titleSection {
    background: var(--button-color-secondary);
    text-decoration: none;

    display: flex;
    gap: 0.75rem;
    padding: 1rem;

    & > span {
      display: inline-flex;
      flex-direction: column;

      .title {
        font-weight: bold;
      }

      button {
        color: var(--red-700);
      }
    }
  }
}
